import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import 'antd/dist/antd.less';
import App from './App';
import { ConfigProvider } from 'antd';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/locale/zh_CN';

ReactDOM.render(<ConfigProvider locale={locale}><App /></ConfigProvider>, document.getElementById('root'));
